import type { AppTemplate } from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import { GITHUB_LINK_DEV_TOOLS_SET } from '../constants/gitHubLinkTemplateTypes';

export const shouldShowGitHubLink = (template: AppTemplate) =>
  template?.repositoryUrl &&
  template.developmentTools?.some((devTool) =>
    GITHUB_LINK_DEV_TOOLS_SET.has(devTool),
  );
